"use client"

import { Clock, CheckCircle2, Brain, Star } from "lucide-react"
import { DashboardStatCard } from "./dashboard-stat-card"

interface DashboardStatsGridProps {
  totalPoints: number;
  tasksCompleted: number;
  streakDays: number;
  level: number;
}

export function DashboardStatsGrid({ totalPoints, tasksCompleted, streakDays, level }: DashboardStatsGridProps) {
  const stats = [
    {
      icon: Clock,
      label: "Time Spent",
      value: "12h 45m",
      iconBgColor: "bg-blue-100",
      iconColor: "text-blue-500",
    },
    {
      icon: CheckCircle2,
      label: "Tasks Done",
      value: "32",
      iconBgColor: "bg-teal-100",
      iconColor: "text-teal-500",
    },
    {
      icon: Brain,
      label: "Skills Earned",
      value: "8",
      iconBgColor: "bg-purple-100",
      iconColor: "text-purple-500",
    },
    {
      icon: Star,
      label: "Points",
      value: "1,250",
      iconBgColor: "bg-amber-100",
      iconColor: "text-amber-500",
    },
  ]

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
      {stats.map((stat, index) => (
        <DashboardStatCard key={index} {...stat} />
      ))}
    </div>
  )
}
